export default {
  downloadPlanJson: 'Baixar JSON do Plano',
  downloadModelJson: 'Baixar JSON do Modelo',
  preparingPlanDownload: 'Preparando os dados do seu plano para download...',
  preparingModelDownload: 'Preparando os dados do seu modelo para download...',
  tryAgain: 'Tentar Novamente',
  planDownloadSuccess: 'Os dados do seu plano foram baixados com sucesso!',
  modelDownloadSuccess: 'Os dados do seu modelo foram baixados com sucesso!',
  closeTabMessage: 'Você pode fechar esta aba agora.',
  readyToDownloadPlan: 'Pronto para baixar o JSON do seu plano.',
  readyToDownloadModel: 'Pronto para baixar o JSON do seu modelo.',
  downloadModelPklFiles: 'Baixar Arquivos PKL do Modelo',
  loadingPklInfo: 'Carregando informações dos arquivos PKL...',
  pklFilesDescription: 'Baixe os arquivos PKL associados a este modelo:',
  downloadModelPkl: 'Baixar PKL do Modelo',
  modelPklNotAvailable: 'Arquivo PKL do modelo não disponível',
  downloadPlanPkl: 'Baixar PKL do Plano',
  planPklNotAvailable: 'Arquivo PKL do plano não disponível',
  noPklFilesAvailable: 'Não há arquivos PKL disponíveis para este modelo.',
  pklReasonUnauthorized: 'Sua conta não tem permissão para ler os arquivos do modelo. Apenas Scientists e Admins podem baixar arquivos PKL.',
  pklReasonNotFound: 'O arquivo não foi encontrado no storage em {path}.',
  pklReasonUnknown: 'O storage retornou um erro: {error}',
  pklReasonNoPath: 'Não foi possível determinar a localização no storage deste arquivo PKL a partir dos dados do modelo.',
  deletedPlanTitle: 'Este plano foi excluído',
  deletedPlanExplanation: 'Mostrando a cópia salva quando o plano foi enviado para execução. Contém apenas os dados de entrada do plano, sem resultados.',
  deletedPlanQueuedOn: 'Cópia salva em {date}',
  deletedModelTitle: 'Este modelo foi excluído',
  deletedModelExplanation: 'Mostrando o modelo como estava quando foi excluído, guardado na lixeira até ser removido definitivamente. Seus arquivos PKL e seus planos continuam disponíveis até lá.',
  deletedModelDeletedOn: 'Excluído em {date}',
  deletedModelDeletedOnBy: 'Excluído em {date} por {name}',
  deletedModelPurgeOn: 'Será removido definitivamente em {date}',
  modelNotFound: 'Modelo não encontrado. Pode ter sido excluído há mais de 7 dias.',
  planNotFound: 'Plano não encontrado.',
  permissionDenied: 'Sua conta não tem permissão para exportar estes dados. Apenas Scientists e Admins podem.',
  openModelOverview: 'Abrir Visão Geral do Modelo',
  openModelError: 'Não foi possível abrir este modelo. Sua conta pode não ter acesso a ele.',
  authenticationRequired: 'Autenticação necessária. Por favor faça login para baixar dados.',
  noDataFound: 'Nenhum dado encontrado para o(s) ID(s) especificado(s)',
  exportError: 'Ocorreu um erro ao exportar os dados'
}
